import { useEffect, useState } from 'react';
import { ISelect } from '../../../../shared/types/shared';
import {
    OrbitCatalogEnum,
    OrbitCatalogQuery,
} from '../../../../shared/types/orbit';
import { asyncGetOrbitCatalog } from '../../../../services/orbit.service';

export const useOrbitCatalog = (
    catalog: OrbitCatalogEnum,
    query?: OrbitCatalogQuery,
    enabled = true
) => {
    const [items, setItems] = useState<ISelect[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | undefined>();

    useEffect(() => {
        if (!enabled) {
            setItems([]);
            setLoading(false);
            setError(undefined);
            return;
        }

        let active = true;

        setLoading(true);
        setError(undefined);

        asyncGetOrbitCatalog(catalog, query).then(
            ({ items: catalogItems, error: catalogError }) => {
                if (!active) return;
                setItems(catalogItems);
                setError(catalogError);
                setLoading(false);
            }
        );

        return () => {
            active = false;
        };
    }, [catalog, enabled, query?.department_code]);

    return { items, loading, error };
};
